import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export const usePersistValue = (persistSelector, initialValue) => {
  const persistValue = useSelector(persistSelector)
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    if (persistValue !== value) {
      setValue(persistValue)
    }
  }, [persistValue])

  return { value, setValue }
}
